











































import Vue from 'vue'
export default Vue.extend({
    name: 'DataTableFooter',
    props: {
        itemsPerPage: {
            type: [Number, String],
            required: true
        },
        itemsPerPageOptions: {
            type: Array,
            required: false,
            default: () => [5, 10, 15, 30, 50, 100]
        },
        disabledNavigation: {
            type: Boolean,
            required: false,
            default: false
        },
        currentPage: {
            type: [Number, String],
            required: true
        },
        lastPage: {
            type: [Number, String],
            required: true
        },
        showRefresh: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.setNavigatorWidth()
    },
    methods: {
        setNavigatorWidth(): void {
            //  Our width depends on how many pages we have
            let width = 124
            if (this.lastPage < 999) {
                width = 72
            } else if (this.lastPage < 9999) {
                width = 86
            } else if (this.lastPage < 99999) {
                width = 106
            }

            //  Set our page width
            this.$refs.pageInfo.style.width = `${width}px`
        }
    },
    watch: {
        lastPage(): void {
            //  Recalculate the page width every time that our last page changes
            this.setNavigatorWidth()
        }
    }
})
